import { Box, Button, CircularProgress, Paper, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import validator from 'validator';
import { sendPasswordResetMail } from "../services/auth";
import { Link } from "react-router-dom";

const ForgotPassword = () => {

  const [email, set_email] = useState('');
  const [is_saving, set_is_saving] = useState(false);

  const handleSendMail = async (e) => {
    e.preventDefault();
    set_is_saving(true);

    const {data, error} = await sendPasswordResetMail({ email : email })
    set_is_saving(false);
    if(data){
      if(data.success){
        enqueueSnackbar('Password reset email sent !', {
          variant : 'success'
        })
      }else{
        showMailError();
      }
    }
    if(error){
      showMailError()
    }
  }
  
  const showMailError = () => {
    enqueueSnackbar('Email address not found !', {
      variant : 'error'
    })
  }

  return(
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
    >
      <form
        onSubmit={handleSendMail}
      >
        <Paper
          elevation={3}
          sx={{
            width : '550px',
            padding : '20px'
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            label = 'Email'
            size="medium"
            sx={{
              marginBottom : '20px'
            }}
            value={email}
            onChange={(e) => set_email(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled = {
              is_saving ||
              !validator.isEmail(email)
            }
          >
            {is_saving ? <CircularProgress /> : 'Send reset password mail'}
          </Button>

          <Box
            display='flex'
            justifyContent='center'
            sx={{
              marginTop : '20px'
            }}
          >
            <Link
              to='/sign-in'
            >
              Back to login
            </Link>
          </Box>
        </Paper>
      </form>
    </Box>
  )
}

export default ForgotPassword;